<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>New Product Details</v-card-title>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Product Code*</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-text-field
                v-model="product.productCode"
                :error="!!productCodeErrors.length"
                :error-messages="productCodeErrors"
                outlined
                dense
              />
            </v-flex>
          </v-layout>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Manufacturer*</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-text-field
                v-model="product.manufacturer"
                outlined
                label
                dense
              />
            </v-flex>
          </v-layout>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Category*</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-combobox
                v-model="product.category"
                :items.sync="categories"
                hide-selected
                small-chips
                solo
                dense
                item-value="_id"
                full-width
                :allow-overflow="false"
                flat
                outlined
                @input="setCategory"
                @keyup.186="setCategory"
                @keyup.13="setCategory"
                @keyup.32="setCategory"
                @change="checkAddCategory"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <!-- shown in selected -->
                  <div>{{ item.name }}</div>
                </template>
                <template v-slot:item="{ index, item }">
                  <!-- shown in list of options -->
                  <v-layout>
                    <v-flex xs12>{{ item.name }}</v-flex>
                  </v-layout>
                </template>
              </v-combobox>
            </v-flex>
          </v-layout>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Subcategory</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-combobox
                :disabled="!subcategories.length"
                v-model="product.subcategory"
                :items.sync="subcategories"
                @input="checkAddSubcategory"
                @change="checkAddSubcategory"
                hide-selected
                small-chips
                solo
                dense
                item-value="_id"
                full-width
                :allow-overflow="false"
                flat
                outlined
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <!-- shown in selected -->
                  <div>{{ item.name }}</div>
                </template>
                <template v-slot:item="{ index, item }">
                  <!-- shown in list of options -->
                  <v-layout>
                    <v-flex xs12>{{ item.name }}</v-flex>
                  </v-layout>
                </template>
              </v-combobox>
            </v-flex>
          </v-layout>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Description*</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-text-field
                v-model="product.description"
                outlined
                label
                dense
              />
            </v-flex>
          </v-layout>
          <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Cost*</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-text-field
                v-model="product.invoicePrice"
                type="number"
                outlined
                label
                dense
              />
            </v-flex>
          </v-layout>
          <!-- <v-layout ml-4 wrap mr-4>
            <v-flex xs12 sm4 md4 lg2>
              <v-subheader>Images</v-subheader>
            </v-flex>
            <v-flex xs10 md8 lg6>
              <v-file-input
                v-model="images"
                color="primary accent-4"
                counter
                label="Images"
                multiple
                dense
                placeholder="Select images"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary accent-4" dark label small>{{ text }}</v-chip>

                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >+{{ images.length - 2 }} File(s)</span>
                </template>
              </v-file-input>
            </v-flex>
          </v-layout> -->
          <div v-for="(attribute, index) in product.attributes" :key="index">
            <v-layout ml-4 wrap mr-4>
              <v-flex xs10 sm4 md4 lg2 pr-2>
                <v-text-field
                  placeholder="New field"
                  readonly
                  v-model="product.attributes[index].text"
                  outlined
                  dense
                />
              </v-flex>
              <v-flex xs10 md8 lg6>
                <v-text-field
                  placeholder="Field value"
                  v-model="product.attributes[index].value"
                  outlined
                  label
                  dense
                />
              </v-flex>
              <v-flex xs2 ml-2>
                <v-icon @click="removeField(index)" color="error"
                  >remove_circle</v-icon
                >
              </v-flex>
            </v-layout>
          </div>
          <v-card-actions>
            <v-flex>
              <v-btn
                :disabled="!validProduct"
                @click="saveProduct"
                color="success"
              >
                Save New Product
                <v-icon right>save</v-icon>
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn @click="addField" color="primary">
                Add Field
                <v-icon right>add</v-icon>
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <add-category-modal
      v-if="addCategoryModal"
      title="Add Product Category"
      :addCategoryModal.sync="addCategoryModal"
      @addCategory="saveNewCategory"
    />
    <add-subcategory-modal
      v-if="addSubcategoryModal"
      title="Add Product Subcategory"
      :addSubcategoryModal.sync="addSubcategoryModal"
      @addSubcategories="addSubcategories"
    />
  </v-container>
</template>

<script>
import request from "@/modules/request";
import AddCategoryModal from "@/components/shared/modals/AddCategoryModal";
import AddSubcategoryModal from "@/components/shared/modals/AddSubcategoryModal";
import shortid from "shortid";
import uniqid from "uniqid";

export default {
  name: "AddProduct",
  inject: ["snackBar"],
  mounted() {
    this.loadData();
  },
  components: {
    AddCategoryModal,
    AddSubcategoryModal,
  },
  data() {
    return {
      productCodeErrors: [],
      loading: false,
      categories: [],
      subcategories: [],
      images: [],
      product: {
        productCode: undefined,
        manufacturer: undefined,
        name: undefined,
        category: undefined,
        subcategory: undefined,
        description: undefined,
        invoicePrice: null,
        assets: {
          images: [],
        },
        attributes: [
          {
            text: "",
            value: "",
            key: uniqid(),
          },
        ],
      },
      addCategoryModal: false,
      addSubcategoryModal: false,
    };
  },
  watch: {
    "product.category"(category) {
      category.fieldSettings.forEach((field) => {
        const { key, text } = field;
        this.product.attributes.unshift({
          key,
          text,
          value: "",
        });
      });
    },
  },
  computed: {
    validProduct() {
      const {
        productCode,
        manufacturer,
        category,
        description,
        invoicePrice,
      } = this.product;

      return (
        productCode &&
        manufacturer &&
        category &&
        category._id &&
        category._id !== "add" &&
        description &&
        invoicePrice &&
        !this.productCodeErrors.length
      );
    },
  },
  methods: {
    async checkUniqueProductCode() {
      const results = await request.callInternal({
        method: "post",
        route: "/api/checkunique",
        data: {
          model: "product",
          field: "productCode",
          value: this.product.productCode.trim(),
        },
      });

      return (this.productCodeErrors = results.data
        ? []
        : ["This product code is already taken"]);
    },
    async saveNewCategory(category) {
      const { data: newCategory } = await request
        .callInternal({
          method: "post",
          route: "/api/admin/category",
          data: category,
        })
        .catch((error) => {
          console.error("error adding category", error);
          return error;
        });

      if (category.subcategories.length) {
        const subcategoryProms = category.subcategories.map(async (sub) => {
          const { _id } = newCategory;
          const { name } = sub;
          return this.addSubcategory(name, _id);
        });

        const newSubcategories = await Promise.all(subcategoryProms).catch(
          (error) => {
            console.error("add subcategory promises error", error);
          }
        );

        const results = await request.callInternal({
          route: `/api/admin/companycategorymarkup`,
          method: "post",
          data: {
            newCategory,
            newSubcategories,
          },
        });
      }

      this.snackBar("Category added!", "success");
      this.addCategoryModal = false;
      this.product.category = newCategory;
      this.subcategories = [{ name: "Add Subcategory", _id: "add" }];
      this.loadData();
    },
    async addSubcategories(subcategories) {
      const categoryId = this.product.category._id;
      const proms = subcategories.map(async (sub) => {
        const { name } = sub;
        return this.addSubcategory(name, categoryId);
      });

      const newSubcategories = await Promise.all(proms).catch((error) => {
        console.log("Add subcategories error...", error);
      });

      await request
        .callInternal({
          method: "post",
          route: "/api/admin/companysubcategorymarkup",
          data: {
            category: categoryId,
            newSubcategories,
          },
        })
        .catch((error) => {
          console.error("Eror adding subcategory to category", error);
        });

      this.snackBar("Added subcategory!", "success");
      this.addSubcategoryModal = false;
      await this.loadData();
      this.product.subcategory = newSubcategories[0];
      this.setCategory(
        this.categories.find((category) => category._id === categoryId)
      );
      this.product.subcategory = newSubcategories[0];
    },
    async addSubcategory(name, category) {
      const { data: newSubcategory } = await request
        .callInternal({
          method: "post",
          route: "/api/admin/subcategory",
          data: {
            name,
            category,
          },
        })
        .catch((error) => {
          console.error("Add subcategory error", error);
          return error;
        });
      return newSubcategory;
    },
    checkAddCategory(opts) {
      if (opts._id === "add") {
        this.addCategoryModal = true;
      }
    },
    checkAddSubcategory(opts) {
      if (opts._id === "add") {
        // open add subcategory modal
        this.addSubcategoryModal = true;
      }
    },
    setCategory(opts) {
      this.product.subcategory = null;
      // if (opts._id !== "add") {
      this.subcategories = [
        ...opts.subcategories,
        { name: "Add Subcategory", _id: "add" },
      ];
      // }
    },
    async loadData() {
      const { getCategories } = this;
      await Promise.all([getCategories()]).then((results) => {
        const [categories] = results;
        this.categories = [...categories, { name: "Add Category", _id: "add" }];
      });
    },
    getCategories() {
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .then((results) => {
          return results.data;
        });
    },
    addField() {
      this.product.attributes.push({
        text: "",
        value: "",
        key: uniqid(),
      });
    },
    removeField(index) {
      this.product.attributes.splice(index, 1);
    },
    async getPresignedUrl(fileName, fileType) {
      return await request.callInternal({
        method: "get",
        route: `/api/admin/presignedurl/?fileName=${fileName}&fileType=${fileType}`,
      });
    },
    async uploadImages() {
      const uploadPromises = this.images.map(async (file) => {
        const uniqueFileName = `${shortid.generate()}_${file.name}`;
        const { data: presignedUrl } = await this.getPresignedUrl(
          uniqueFileName,
          file.type
        );
        this.product.assets.images.push({
          key: uniqueFileName,
        });
        return request
          .callExternal({
            method: "PUT",
            url: presignedUrl,
            headers: {
              "Content-Type": file.type,
            },
            data: file,
          })
          .then((results) => {
            return results;
          })
          .catch((error) => {
            console.error("error uploading image", error);
          });
      });

      await Promise.all(uploadPromises).catch((error) => {
        console.log("upload proms error", error);
      });
    },
    async saveProduct() {
      if (this.images.length) {
        await this.uploadImages();
      }

      if (this.product.subcategory && this.product.subcategory._id === "add") {
        this.product.subcategory = undefined;
      }
      request
        .callInternal({
          method: "post",
          route: "/api/admin/products/",
          data: this.product,
        })
        .then((results) => {
          this.$swal({
            title: "Congratulations!",
            text: `Your new product was successfully saved.`,
            icon: "success",
          });
          Object.assign(this.product, {
            productCode: undefined,
            manufacturer: undefined,
            name: undefined,
            category: undefined,
            subcategory: undefined,
            description: undefined,
            invoicePrice: null,
            assets: {
              images: [],
            },
            attributes: [
              {
                text: "",
                value: "",
                key: uniqid(),
              },
            ],
          });
          this.images = [];
          this.loadData();
        })
        .catch((error) => {
          console.error(error);
          // TODO - improve error handling (in general)
          this.$swal({
            title: "Error",
            text:
              "Something went wrong with saving this product. Please make sure the Product Code is unique and try again",
            icon: "error",
          });
        });
    },
  },
};
</script>
